import { MagnusCrest, MagnusCrestSvg } from "./Logo";

const CORNERS = [
    "top-2.5 left-2.5 z-10",
    "top-2.5 right-2.5 rotate-90 z-10",
    "bottom-2.5 right-2.5 rotate-180 z-10",
    "bottom-2.5 left-2.5 -rotate-90 z-10",
];

const Corner = ({ pos }) => (
    <svg
        className={`absolute ${pos} w-4 h-4 text-gold/70`}
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden="true"
    >
        <path
            d="M1.5 15V4.5C1.5 2.8 2.8 1.5 4.5 1.5H15"
            stroke="currentColor"
            strokeWidth="1.2"
        />
        <circle cx="1.5" cy="15" r="1.3" fill="currentColor" />
    </svg>
);

export default function PhotoFrame({
    label,
    img,
    ratio = "aspect-[4/5]",
    className = "",
    testId,
    dark = false,
    caption = "Foto do produto",
}) {
    return (
        <div
            data-testid={testId}
            className={`group relative ${ratio} ${className} overflow-hidden rounded-[3px] border transition-all duration-500 ${
                dark
                    ? "border-gold/30 bg-white/[0.03]"
                    : "border-gold/35 bg-gradient-to-br from-amber-50/70 via-[#FBFAF7] to-amber-100/50 shadow-frame hover:shadow-gold hover:border-gold/60"
            }`}
        >
            {img && (
                <img
                    src={img}
                    alt={label || "Produto Magnus Personalizados"}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                />
            )}
            {!img && (
                <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-center px-6">
                    {dark ? (
                        <MagnusCrestSvg className="w-9" />
                    ) : (
                        <MagnusCrest className="w-9" />
                    )}
                    <p
                        className={`font-accent text-[9px] uppercase tracking-[0.35em] ${
                            dark ? "text-cream/40" : "text-ink/40"
                        }`}
                    >
                        {caption}
                    </p>
                    {label && (
                        <p
                            className={`font-body text-xs leading-snug ${
                                dark ? "text-cream/55" : "text-ink/55"
                            }`}
                        >
                            {label}
                        </p>
                    )}
                </div>
            )}
            <div
                className={`absolute inset-[7px] border pointer-events-none z-10 ${
                    dark ? "border-gold/20" : "border-gold/25"
                }`}
            />
            {CORNERS.map((pos) => <Corner key={pos} pos={pos} />)}
            {!img && (
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(212,175,55,0.14),transparent_55%)] pointer-events-none" />
            )}
        </div>
    );
}
